import React, { Suspense, ReactNode } from 'react';

// Loading component
const LoadingFallback = () => {
  return <div className="loading-container">Loading...</div>;
};

interface LazyComponentProps {
  children: ReactNode;
}

/**
 * Wrapper component that provides Suspense fallback for lazy-loaded components
 */
const LazyComponent: React.FC<LazyComponentProps> = ({ children }) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      {children}
    </Suspense>
  );
};

export default LazyComponent; 